export default "__VITE_ASSET__DxeYQb4J__"